<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="{ name: 'newJob' }">
          <v-btn color="primary">{{ $t('jobs.new_job') }}</v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <data-table-with-pagination
          :headers="jobs_header"
          :dataList="jobs_list"
          :loading="load_table"
          :options="options"
          :itemLength="total_items"
        ></data-table-with-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getData } from '@/api'
import DataTableWithPagination from '@/components/DataTableWithPagination.vue'
import { globalFunc } from '@/global'
export default {
  name: 'Jobs',
  components: {
    DataTableWithPagination,
  },
  mixins: [globalFunc],
  data: () => ({
    jobs_header: [],
    jobs_list: [],
    load_table: true,
    total_items: 0,
    current_page: 0,
    current_limit: 10,
    options: {},
  }),
  methods: {
    initializeHeader() {
      this.jobs_header = [
        {
          text: this.$t('jobs.publish_date'),
          value: 'publish_date',
          width: '115px',
        },
        {
          text: this.$t('jobs.job_title'),
          value: 'title',
        },
        { text: '', value: 'jobs_button', width: '210px' },
      ]
    },
    async initializeData() {
      try {
        this.load_table = true

        let params = new URLSearchParams()
        params.set('get_published_job', JSON.stringify({}))

        let jobs = await getData(params)

        let temp = []

        this.total_items = jobs.length

        for (let i = 0; i < jobs.length; i++) {
          let obj = jobs[i]
          temp.push({
            id: obj.id,
            publish_date: obj.publish_date,
            title: obj.title,
          })
        }

        this.jobs_list = temp
        this.load_table = false
      } catch (error) {
        globalFunc.log(error)
        this.load_table = false
      }
    },
  },
  created() {
    this.initializeHeader()
    this.initializeData()
  },
}
</script>
